import React from 'react';
import classNames from 'classnames/bind';

import styles from './styles.scss';
import PageContainer from 'containers/en/page-container';
import { useTranslation } from 'hooks/use-translation';

const cx = classNames.bind(styles);




function PageMain(props: Record<string, any>) {
	const { transData } = useTranslation('teams')
	const { title, timelineData, historyData, rightTitle } = transData
	return (
		<PageContainer>
			<div className={cx('teams-careers')}>
				<div className={cx('banner')}></div>
				<div className={cx('title')}>{title}</div>
				<div className={cx('careers-wrap')}>
					<div className={cx('timeline-wrap')}>
						{timelineData.map((item: any) => (
							<div className={cx('timeline-item')} key={item.year}>
								<div className={cx('year')}>{item.year}</div>
								<div className={cx('line-wrap')}>
									<div className={cx('dot')}></div>
									<div className={cx('line')}></div>
								</div>
								<div className={cx('desc')}>
									<div className={cx('desc-title')}>{item.title}</div>
									<div className={cx('content')}>{item.content}</div>
								</div>
							</div>
						))}
					</div>
					<div className={cx('new-history-wrap')}>
						<div className={cx('history-title')}>{rightTitle}</div>
						<div className={cx('history-wrap')}>
							{historyData.map((item: any, idx: number) => (
								<div className={cx('history-item')} key={idx}>
									<div className={cx('icon')}>
										<img src={item.icon} />
									</div>

									<div className={cx('desc')}>
										<div className={cx('count')}>{item.count}</div>
										<div className={cx('txt')}>{item.txt}</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</PageContainer>
	);
}

export default PageMain;
